import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {DeliveryPointRemote} from "@app/core/delivery-point/domain/delivery-point.remote";
import {DeliveryPoint} from "@app/core/delivery-point/application/dtos/delivery-point";
import {Credentials} from "@app/core/credentials/domain/credentials";

/**
 * Use case for retrieving the list of available delivery points for the current user.
 */
@Injectable({
    providedIn: "root",
})
export class GetDeliveryPointsUseCase {
    constructor(
        private deliveryPointRemote:DeliveryPointRemote,
    ) {}

    /**
     * Executes the use case to retrieve delivery points available for the user.
     *
     * @param credentials Optional credentials used to fetch delivery points before completing login.
 *                      This happens when the user is not logged in and is in the "Select delivery point" step.
     * @returns An observable containing an array of delivery points.
     */
    execute(credentials?: Credentials): Observable<DeliveryPoint[]> {
        return this.deliveryPointRemote.getDeliveryPoints(credentials);
    }
}